import React from 'react';
import * as MetaSftpTypes from './metaSftp.types';
import { metaError } from 'utils/errorCodes';
import { notificationErr } from 'views/components/UI/notification';
import * as msg from 'views/components/UI/message';
import * as api from 'api/endpoints/meta/meta.api';
import * as metaResponseInterface from 'api/endpoints/meta/meta.response.interface';
import { ITranslate } from 'interfaces/general.interface';
import { TSftpUserItem } from 'interfaces/meta.interface';
import { TMetaSftpsDispatchReducer } from './metaSftp.reducer';

export async function deleteSftpConnectionAction(
  dispatch: React.Dispatch<TMetaSftpsDispatchReducer>,
  user_name: string,
  token: string,
  translate: ITranslate
) {
  dispatch({
    type: MetaSftpTypes.SET_IS_LOADING_DELETE_SFPT_CONNECTIONS,
    payload: { loading: true, user_name: user_name },
  });
  try {
    const deleteSftpUserConnectionFetch = await api.deleteSftpUserAPI({
      user_name,
      token,
    });
    if (deleteSftpUserConnectionFetch.response.status === 200) {
      msg.messageSuccess(translate('action_meta_delete-connection_success'));
      return dispatch({
        type: MetaSftpTypes.DELETE_SFTP_CONNECTION,
        payload: user_name,
      });
    } else {
      msg.messageError(translate('action_meta_delete-connection_error'));
      notificationErr(metaError.delete_sftp_connection_002, translate);
    }
  } catch (error) {
    msg.messageError(translate('action_meta_delete-connection_error'));
    notificationErr(metaError.delete_sftp_connection_001, translate);
  } finally {
    dispatch({
      type: MetaSftpTypes.SET_IS_LOADING_DELETE_SFPT_CONNECTIONS,
      payload: { loading: false, user_name: '' },
    });
  }
}

export async function createSftpConnectionAction(
  dispatch: React.Dispatch<TMetaSftpsDispatchReducer>,
  body: metaResponseInterface.TcreateSftpUserAPIBodyProps,
  token: string,
  translate: ITranslate
) {
  dispatch({
    type: MetaSftpTypes.SET_IS_LOADING_CREATE_SFPT_CONNECTIONS,
    payload: true,
  });
  try {
    const createSftpUserConnectionFetch = await api.createSftpUserAPI({
      body,
      token,
    });

    if (createSftpUserConnectionFetch.response.status === 403) {
      msg.messageWarning(translate('action_meta_create-sftp-connection_error-403'));
      return false;
    }

    if (createSftpUserConnectionFetch.response.status === 200) {
      msg.messageSuccess(translate('action_meta_create-connection_success'));
      const newSftpConnection: TSftpUserItem = {
        ...createSftpUserConnectionFetch.data,
        type: 'sftp',
      };
      dispatch({
        type: MetaSftpTypes.ADD_NEW_CONNECTION,
        payload: newSftpConnection,
      });
      return true;
    } else {
      msg.messageError(translate('action_meta_create-connection_error'));
      notificationErr(metaError.create_sftp_connection_002, translate);
      return false;
    }
  } catch (error) {
    msg.messageError(translate('action_meta_create-connection_error'));
    notificationErr(metaError.create_sftp_connection_001, translate);
    return false;
  } finally {
    dispatch({
      type: MetaSftpTypes.SET_IS_LOADING_CREATE_SFPT_CONNECTIONS,
      payload: false,
    });
  }
}

export async function updateSftpConnectionAction(
  dispatch: React.Dispatch<TMetaSftpsDispatchReducer>,
  body: TSftpUserItem,
  token: string,
  translate: ITranslate
): Promise<boolean> {
  dispatch({
    type: MetaSftpTypes.SET_IS_LOADING_UPDATE_SFPT_CONNECTIONS,
    payload: {
      connectionId: body.id,
      loading: true,
    },
  });
  try {
    const updateSftpUserConnectionFetch = await api.updateSftpUserAPI({
      body,
      token,
    });

    if (updateSftpUserConnectionFetch.response.status === 200) {
      msg.messageSuccess(translate('action_meta_update-connection_success'));
      dispatch({
        type: MetaSftpTypes.UPDATE_CONNECTION,
        payload: body,
      });
      return true;
    } else {
      msg.messageError(translate('action_meta_update-connection_error'));
      notificationErr(metaError.update_sftp_connection_002, translate);
      return false;
    }
  } catch (error) {
    msg.messageError(translate('action_meta_update-connection_error'));
    notificationErr(metaError.update_sftp_connection_001, translate);
    return false;
  } finally {
    dispatch({
      type: MetaSftpTypes.SET_IS_LOADING_UPDATE_SFPT_CONNECTIONS,
      payload: {
        connectionId: null,
        loading: false,
      },
    });
  }
}

export function setConnectionSelectedAction({
  dispatch,
  connectionId,
}: {
  dispatch: React.Dispatch<TMetaSftpsDispatchReducer>;
  connectionId: string | null;
}) {
  dispatch({
    type: MetaSftpTypes.SET_SFTP_CONNECTION_SELECTED,
    payload: connectionId,
  });
}
